"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Avatar_1 = __importDefault(require("../Avatar"));
var GeneralSettings_1 = require("../../constants/GeneralSettings");
var classnames_1 = __importDefault(require("classnames"));
var react_i18next_1 = require("react-i18next");
var banali_avatar_svg_1 = __importDefault(require("../../../images/banali-avatar.svg"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Contacts = react_1.memo(function (_a) {
    var contacts = _a.contacts, owner = _a.owner;
    var t = react_i18next_1.useTranslation('common').t;
    var _b = react_1.useState(false), seeMore = _b[0], setSeeMore = _b[1];
    var mainContact = contacts
        ? contacts[0]
        : {
            formattedPhone: GeneralSettings_1.GENERAL_SETTINGS.CONTACT_PHONE.PHONE_NUMBER,
            messengers: GeneralSettings_1.GENERAL_SETTINGS.CONTACT_PHONE.MESSENGERS,
        };
    var getMessengers = function (messengers, phone) {
        if (messengers === void 0) { messengers = GeneralSettings_1.GENERAL_SETTINGS.CONTACT_PHONE.MESSENGERS; }
        if (phone === void 0) { phone = GeneralSettings_1.GENERAL_SETTINGS.CONTACT_PHONE.PHONE_NUMBER; }
        return messengers.map(function (value, index) {
            if (value == GeneralSettings_1.MESSENGERS.VIBER) {
                return (react_1.default.createElement("a", { href: 'viber://chat?number=' + phone, key: index },
                    react_1.default.createElement("i", { className: classnames_1.default('cm-icon', 'icon-ic-' + value) })));
            }
            if (value == GeneralSettings_1.MESSENGERS.WHATSAPP) {
                return (react_1.default.createElement("a", { href: 'https://wa.me/' + phone, key: index },
                    react_1.default.createElement("i", { className: classnames_1.default('cm-icon', 'icon-ic-' + value) })));
            }
            if (value == GeneralSettings_1.MESSENGERS.TELEGRAM) {
                return (react_1.default.createElement("a", { href: 'tg://msg?to=' + phone, key: index },
                    react_1.default.createElement("i", { className: classnames_1.default('cm-icon', 'icon-ic-' + value) })));
            }
        });
    };
    var getExtraContacts = function (contacts) {
        return contacts
            .filter(function (element, index) { return index != 0; })
            .map(function (value, index) {
            return (react_1.default.createElement("div", { className: styles_module_scss_1.default.more_contact_numbers, key: index },
                react_1.default.createElement("a", { href: 'tel:' + value.formattedPhone, className: styles_module_scss_1.default.phone_number, placeholder: "phone number" },
                    react_1.default.createElement("i", { className: "cm-icon icon-ic-phone-circle" })),
                getMessengers(value.messengers, value.formattedPhone),
                react_1.default.createElement("a", { href: 'tel:' + value.formattedPhone, className: styles_module_scss_1.default.extra_phone_number, placeholder: "Phone number" }, value.formattedPhone)));
        });
    };
    var onSeeMoreChange = function () {
        setSeeMore(!seeMore);
    };
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.contacts },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.main_contacts },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.owner_contacts },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.avatar }, owner ? (react_1.default.createElement(Avatar_1.default, { img: owner.avatar, name: owner.username })) : (react_1.default.createElement("img", { className: styles_module_scss_1.default.banali_avatar, src: banali_avatar_svg_1.default, alt: "Banali", title: "banali" }))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.info },
                    react_1.default.createElement("p", { className: styles_module_scss_1.default.name }, owner ? owner.username : GeneralSettings_1.GENERAL_SETTINGS.APP_NAME),
                    !owner && (react_1.default.createElement("p", { className: styles_module_scss_1.default.email }, GeneralSettings_1.GENERAL_SETTINGS.EMAIL)))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.contact_numbers },
                react_1.default.createElement("a", { href: 'tel:' + mainContact.formattedPhone, className: styles_module_scss_1.default.phone_number, placeholder: "phone number" }, mainContact.formattedPhone),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.messengers },
                    react_1.default.createElement("a", { href: 'tel:' + mainContact.formattedPhone, className: styles_module_scss_1.default.phone_number, placeholder: "phone number" },
                        react_1.default.createElement("i", { className: "cm-icon icon-ic-phone-circle" })),
                    getMessengers(mainContact.messengers, mainContact.formattedPhone)))),
        contacts && contacts.length > 1 && (react_1.default.createElement("div", { className: styles_module_scss_1.default.more },
            react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.more_contacts, !seeMore && styles_module_scss_1.default.hidden) }, getExtraContacts(contacts)),
            react_1.default.createElement("button", { className: styles_module_scss_1.default.more_btn, onClick: onSeeMoreChange },
                react_1.default.createElement("p", null, t(seeMore
                    ? 'CONTACTS_SHOW.LESS'
                    : 'CONTACTS_SHOW.MORE')),
                react_1.default.createElement("i", { className: classnames_1.default('cm-icon', 'icon-chevron-down', seeMore && styles_module_scss_1.default.turn) }))))));
});
exports.default = Contacts;
